import React, { useEffect, useMemo } from "react";
import GroupIcon from "@mui/icons-material/Group";
import InfoIcon from "../../Assets/NewByrneIcons/IT request.svg";
import InfoIconHover from "../../Assets/NewByrneIcons/IT request - Hover.svg";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import bidash from "../../Assets/NewByrneIcons/Dashboard BI.svg";
import bidashHover from "../../Assets/NewByrneIcons/Dashboard BI - hover.svg";
import chatBot from "../../Assets/NewByrneIcons/Chat Bot.svg";
import chatBotHover from "../../Assets/NewByrneIcons/Chat Bot - hover.svg";
import closeIcon from "../../Assets/Images/panel - close.svg";
import openIcon from "../../Assets/Images/Panel open.svg";
import byrneHrms from "../../Assets/departmentContentEditor/Byrne HRMS.svg";
import byrneHrmsHover from "../../Assets/NewByrneIcons/Byrne HRMS - Hover.svg";
import byrneERP from "../../Assets/departmentContentEditor/byrne  - department.svg";
import byrneERPHover from "../../Assets/NewByrneIcons/byrne - department - hover.svg";
import PhoneIcon from "@mui/icons-material/Phone";
import byrneCRM from "../../Assets/departmentContentEditor/crm.svg";
import byrneCRMHover from "../../Assets/NewByrneIcons/crm - hover.svg";
import SpCRM from "../../Assets/departmentContentEditor/sp - department - hover-1.svg";
import SpCRMHover from "../../Assets/NewByrneIcons/sp - department.svg";
import knowIcon from "../../Assets/NewByrneIcons/Knowledge Center.svg";
import knowIconHover from "../../Assets/NewByrneIcons/Knowledge Center - hover.svg";
import employeeIcon from "../../Assets/NewByrneIcons/phone.svg";
import galleryIconHover from "../../Assets/NewByrneIcons/Gallery.svg";
import galleryIcon from "../../Assets/NewByrneIcons/Gallery - Active.svg";
import employeeIconHover from "../../Assets/NewByrneIcons/phone  - hover.svg";
import Gallery from "./../../Assets/byrne - svg/gallery - white.svg";
import GalleryH from "./../../Assets/byrne - svg/gallery.svg";
import videoIconHover from "../../Assets/NewByrneIcons/Video-icon-hover.svg";
import videoIcon from "../../Assets/NewByrneIcons/Video-icon.svg";
import { Box, Typography, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import "./SidebarMenu.css";
import { link } from "fs";
import { useGetquickLinksDataQuery } from "../../Services/APIs";

const SidebarMenu = () => {
  // Fetch useful links data from API
  const { data: quickLinksData, isLoading, error, refetch } = useGetquickLinksDataQuery();

  // Refetch data on component mount to ensure fresh data
  useEffect(() => {
    refetch();
  }, [refetch]);

  // Transform API data to match component structure
  const products = useMemo(() => {
    if (!quickLinksData?.result) return [];

    return quickLinksData.result
      // Filter only active links
      .filter((item: any) => item.isActive === true)
      // Sort by order field
      .sort((a: any, b: any) => (a.order || 0) - (b.order || 0))
      // Map API fields to component structure
      .map((item: any) => ({
        icon: item.Icon, // Base64 image or URL
        hoverIcon: item.IconHover, // Base64 image or URL
        label: item.label,
        link: item.url,
        newTab: item.newTab,
      }));
  }, [quickLinksData]);
  // Show loading state
  if (isLoading) {
    return (
      <div>
        <div className="mainMenuContainer">
          <div>
            <Typography className="useFull-new-text">
              USEFUL LINKS
            </Typography>
            <Box display="flex" justifyContent="center" padding="20px">
              <CircularProgress size={24} style={{ color: "#e0001b" }} />
            </Box>
          </div>
        </div>
      </div>
    );
  }

  // Show error state (fallback to empty if error)
  if (error) {
    console.error("Error fetching useful links:", error);
  }

  return (
    <div>
      <div className="mainMenuContainer">
        {/* {showQuickLinks && ( */}
        <div>
          <Typography className="useFull-new-text">
            USEFUL LINKS
            {/* <span
                      onClick={toggleQuickLinks}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={closeIcon}
                        alt="Close"
                        style={{
                          float: "right",
                          padding: "4px",
                          borderRadius: "50%",
                          fontWeight: "bold",
                        }}
                      />
                    </span> */}
          </Typography>
          {/* <Box>
            {products.map((product, index) => (
              <div key={index}>
                <Link to={product.link} className="useFull-div">
                  <div className="icons-new-use">{product.icon}</div>
                  <span className="label-new-link">{product.label}</span>
                </Link>
              </div>
            ))}
          </Box> */}
          <Box>
            {products.map((product: any, index: number) => {
              // Determine if link is internal or external
              const isInternalLink = product.link.startsWith("/");
              const shouldOpenInNewTab = product.newTab || !isInternalLink;

              return (
                <div key={index}>
                  {!shouldOpenInNewTab ? (
                    <Link to={product.link} className="useFulldiv">
                      <div className="icons-new-use">
                        <img
                          src={product.icon}
                          alt={`${product.label} icon`}
                          style={{ width: "18px" }}
                        />
                        <img
                          src={product.hoverIcon}
                          alt={`${product.label} hover icon`}
                          style={{ width: "18px" }}
                        />
                      </div>
                      <span className="label-new-link">{product.label}</span>
                    </Link>
                  ) : (
                    <a target="_blank" href={product.link} className="useFulldiv" rel="noopener noreferrer">
                      <div className="icons-new-use">
                        <img
                          src={product.icon}
                          alt={`${product.label} icon`}
                          style={{ width: "18px" }}
                        />
                        <img
                          src={product.hoverIcon}
                          alt={`${product.label} hover icon`}
                          style={{ width: "18px" }}
                        />
                      </div>
                      <span className="label-new-link">{product.label}</span>
                    </a>
                  )}
                </div>
              );
            })}
          </Box>
        </div>
        {/* )} */}
        {/* {!showQuickLinks && (
                  <div>
                    <div>
                      <IconButton onClick={toggleQuickLinks}>
                        <img
                          src={openIcon}
                          alt="Open"
                          style={{ color: "#ffffff" }}
                        />
                      </IconButton>
                    </div>
                    <Box style={{ height: "auto" }}>
                      {products.map((product, index) => (
                        <Link
                          to={product.link}
                          key={index}
                          className="useFull-link"
                        >
                          <Tooltip
                            title={product.label}
                            placement="right-start"
                          >
                            <div className="usesIcon">{product.icon}</div>
                          </Tooltip>
                        </Link>
                      ))}
                    </Box>
                  </div>
                )} */}
      </div>
    </div>
  );
};

export default SidebarMenu;
